import React, { useEffect } from 'react'

import { useSelector } from 'react-redux'

import { faSitemap } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Tabs } from 'antd'

import Students from './Students.jsx'
import SupervisedStudents from './SupervisedStudents.jsx'
import Analytics from '../../../utils/analytics.js'
import { isSupervisor } from '../../../utils/roles.js'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer.js'
import { selectUser } from '../../../reducers/UserReducer/index.js'

const { TabPane } = Tabs

const SchoolStudentsView = () => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  useEffect(() => Analytics.pageView('/school-students'), [])

  return (
    <Tabs defaultActiveKey='1' animated={false}>
      <TabPane
        key='1'
        tab={
          <div className='flex-row'>
            <FontAwesomeIcon icon='user-graduate' style={{ marginTop: '3px' }} />
            <div className='h-spacing' />
            {t('School students')}
          </div>
        }
      >
        <Students />
      </TabPane>
      {isSupervisor(user) &&
        <TabPane
          key='2'
          tab={
            <div className='flex-row'>
              <FontAwesomeIcon icon={faSitemap} style={{ marginTop: '3px' }} />
              <div className='h-spacing' />
              {t('My students')}
            </div>
          }
        >
          <SupervisedStudents />
        </TabPane>}
    </Tabs>
  )
}

export default SchoolStudentsView
